import _ from 'lodash';
import shortid from 'shortid';
import types from 'frontend/state/actionTypes';

const savedGearsetsReducer = (state = [], action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.SAVE_GEARSET: {
      const gearset = {
        ...payload.gearset,
        id: shortid.generate(),
        name: payload.gearset.name || payload.gearset.defaultName,
      };
      return [
        ...state,
        gearset,
      ];
    }
    case types.DELETE_SAVED_GEARSET:
      return _.reject(state, { id: payload.savedGearsetId });
    default:
      return state;
  }
};

export default savedGearsetsReducer;

export const selectors = {
  savedGearsets: state => state.simbot.savedGearsets,
};
